import {
  VoyageToDataLayerInterface,
  voyageToTrackingEvent
} from "src/utils/analytics/tracking";

export const sendDrawerOpenedTrackingEvent = (
  args: VoyageToDataLayerInterface
) => {
  const event = voyageToTrackingEvent(args);
  window.wspr?.P("cruise_drawer_opened", event);
};
